import { CNodePropsTypeEnum as e, InnerComponentNameEnum as t, LogicType as n } from "@chamn/model";
import r from "@monaco-editor/react";
import { useCallback as i, useEffect as a, useRef as o, useState as s } from "react";
import { Fragment as c, jsx as l, jsxs as u } from "react/jsx-runtime";
//#region src/pages/basePage/index.ts
var d = {
	version: "1.0.0",
	name: "BaseDemoPage",
	componentsMeta: [],
	componentsTree: {
		componentName: "RootContainer",
		props: { a: 1 },
		state: {
			b: 2,
			buttonVisible: !0,
			modalVisible: !1
		},
		configure: {
			propsSetter: {},
			advanceSetter: {}
		},
		children: [{
			props: {
				width: "100px",
				height: "100px"
			},
			componentName: "CContainer",
			id: "ckakcd",
			children: [
				{
					props: {
						width: "100px",
						height: "100px"
					},
					componentName: "CContainer",
					id: "ef9vms",
					children: [{
						props: {
							width: "100px",
							height: "100px",
							$$attributes: [{}]
						},
						componentName: "CContainer",
						id: "2vi5b1",
						eventListener: [{
							name: "ON_DID_RENDER",
							func: {
								type: "ACTION",
								handler: [{
									type: "RUN_CODE",
									id: "base-page-did-render",
									value: "const staticVar = $$context.getStaticVar();\nconsole.log('$$context', $$context)\nlet setTimer = function () {\n  const staticVar = $$context.getStaticVar();\n  if (staticVar.timer) clearInterval(staticVar.timer);\n  if (window.__CHAMN_RENDER_MODE === 'DESIGN') return;\n  const timer = setInterval(() => {\n    const bannerStateObj = $$context.getStateObj();\n    bannerStateObj.updateState((oldState) => ({ ...oldState, currentPage: (oldState.currentPage + 1) % 3 }));\n  }, 2 * 1000);\n  staticVar.timer = timer;\n};\nstaticVar.preScence = function leftClick() {\n  const staticVar = $$context.getStaticVar();\n  if (staticVar.timer) clearInterval(staticVar.timer);\n  const bannerStateObj = $$context.getStateObj();\n  if (bannerStateObj.state.currentPage === 0) { setTimer(); return; }\n  bannerStateObj.updateState({ currentPage: (bannerStateObj.state.currentPage - 1) % 3 });\n  setTimer();\n};\nstaticVar.nextScence = function rightClick() {\n  const staticVar = $$context.getStaticVar();\n  if (staticVar.timer) clearInterval(staticVar.timer);\n  const currentStateObj = $$context.getStateObj();\n  if (currentStateObj.state.currentPage === 2) { setTimer(); return; }\n  currentStateObj.updateState({ currentPage: (currentStateObj.state.currentPage + 1) % 3 });\n  setTimer();\n};\nsetTimer();"
								}]
							}
						}, {
							name: "ON_WILL_DESTROY",
							func: {
								type: "ACTION",
								handler: [{
									type: "RUN_CODE",
									id: "base-page-will-destroy",
									value: "console.log('clear timer 1111');\nif ($$context.staticState.timer) {\n  console.log('clear timer');\n  clearInterval($$context.staticState.timer);\n}"
								}]
							}
						}],
						children: [
							{
								props: {
									width: "100px",
									height: "100px",
									$$attributes: []
								},
								style: [{
									property: "transform",
									value: {
										type: "EXPRESSION",
										value: "`translateX(-${($$context.stateManager.bannerState.state.currentPage) * 100}%) translateZ(0) `"
									}
								}],
								componentName: "CContainer",
								id: "69079u",
								children: [{
									props: {
										width: "100px",
										height: "100px",
										$$attributes: []
									},
									style: [
										{
											property: "width",
											value: "100%"
										},
										{
											property: "background-repeat",
											value: "no-repeat"
										},
										{
											property: "background-position",
											value: "center"
										},
										{
											property: "background-size",
											value: "cover"
										},
										{
											property: "flex-shrink",
											value: "0"
										},
										{
											property: "height",
											value: "100%"
										},
										{
											property: "Webkit-transform",
											value: "translate3d(0, 0, 0)"
										},
										{
											property: "background-image",
											value: {
												type: "EXPRESSION",
												value: "`url(\"${$$context.loopData.item}\")`"
											}
										}
									],
									componentName: "CBlock",
									id: "v59d71",
									configure: {
										propsSetter: {},
										advanceSetter: { "loop.data": {
											name: "loop.data",
											setter: "ExpressionSetter"
										} }
									},
									title: "CBlock-1",
									loop: {
										open: !0,
										data: {
											type: "EXPRESSION",
											value: "$$context.stateManager.bannerState.state.imgList"
										},
										forName: "item",
										forIndex: "index",
										key: "",
										name: ""
									},
									condition: !0,
									classNames: [{
										name: "123",
										status: {
											type: "EXPRESSION",
											value: "$$context.stateManager.bannerState.state.currentPage"
										}
									}, {
										name: "leftBox",
										status: {
											type: "EXPRESSION",
											value: "true"
										}
									}],
									css: {
										class: "v59d71",
										value: [{
											state: "normal",
											media: [{
												type: "max-width",
												value: "991"
											}]
										}, {
											state: "hover",
											media: []
										}]
									}
								}],
								configure: {
									propsSetter: {},
									advanceSetter: {}
								},
								title: "banner-box",
								loop: {
									open: !1,
									data: [],
									forName: "item",
									forIndex: "index",
									key: "",
									name: ""
								},
								condition: !0,
								refId: "bannerBox",
								css: {
									class: "c_69079u",
									value: [{
										state: "normal",
										media: [],
										text: "\n                          display: flex;\n                          width: 100%;\n                          position: absolute;\n                          transition: all 0.3s;\n                          height: 100%;\n                          Webkit-backface-visibility: hidden\n                          "
									}]
								}
							},
							{
								props: {
									width: "",
									height: "",
									$$attributes: [{
										key: "onClick",
										value: {
											type: "FUNCTION",
											value: "function leftClick(e) {\n  const variableSpace =  $$context.getStaticVarById('bannerState')\n  console.log('variableSpace', variableSpace);\n  variableSpace.preScence();\n}"
										}
									}],
									children: {
										type: "EXPRESSION",
										value: ""
									}
								},
								componentName: "CBlock",
								id: "9g9ohd",
								configure: {
									propsSetter: {
										"$$attributes.0.value": {
											name: "$$attributes.0.value",
											setter: "FunctionSetter"
										},
										children: {
											name: "children",
											setter: "ExpressionSetter"
										}
									},
									advanceSetter: {}
								},
								title: "array-left",
								css: {
									class: "c_9g9ohd",
									value: [{
										state: "normal",
										media: [],
										text: "width: 50px;height: 50px;background-color: rgba(0,0,0,0.5);position: absolute;z-index: 999;top: 50%;transform: translateY(-50%);cursor: pointer;border-radius: 4px;left: 10px;"
									}]
								}
							},
							{
								css: {
									class: "c_je9fi5",
									value: [{
										state: "normal",
										media: [],
										text: "width: 50px;height: 50px;background-color: rgba(0,0,0,0.5);position: absolute;z-index: 999;top: 50%;transform: translateY(-50%);right: 10px;cursor: pointer;border-radius: 4px; "
									}]
								},
								props: {
									width: "",
									height: "",
									$$attributes: [{
										key: "onClick",
										value: {
											type: "FUNCTION",
											value: "function rightClick(e) {\n\n  const variableSpace =  $$context.getStaticVarById('bannerState')\n  console.log('variableSpace', variableSpace);\n  variableSpace.nextScence();\n}"
										}
									}]
								},
								componentName: "CBlock",
								configure: {
									propsSetter: { "$$attributes.0.value": {
										name: "$$attributes.0.value",
										setter: "FunctionSetter"
									} },
									advanceSetter: {}
								},
								title: "array-right",
								id: "je9fi5"
							},
							{
								style: [
									{
										value: "absolute",
										property: "position"
									},
									{
										value: "10px",
										property: "bottom"
									},
									{
										value: "50%",
										property: "left"
									},
									{
										value: "translateX(-50%)",
										property: "transform"
									},
									{
										value: "20px",
										property: "height"
									},
									{
										value: "flex",
										property: "display"
									},
									{
										value: "center",
										property: "align-items"
									},
									{
										value: "rgba(0,0,0,0.5)",
										property: "background-color"
									},
									{
										value: "10px",
										property: "border-radius"
									},
									{
										value: "0 10px",
										property: "padding"
									},
									{
										value: "space-around",
										property: "justify-content"
									},
									{
										value: "80px",
										property: "width"
									}
								],
								props: {
									width: "100px",
									height: "100px"
								},
								componentName: "CContainer",
								id: "bl87pg",
								children: [{
									props: {
										width: "",
										height: "",
										$$attributes: [{
											key: "onClick",
											value: {
												type: "FUNCTION",
												value: "function click() {\n  console.log($$context.loopData);\n}"
											}
										}]
									},
									componentName: "CBlock",
									id: "jn98v0",
									configure: {
										propsSetter: {
											"$$attributes.0.value": {
												name: "$$attributes.0.value",
												setter: "FunctionSetter"
											},
											children: {
												name: "children",
												setter: "ExpressionSetter"
											}
										},
										advanceSetter: { "loop.data": {
											name: "loop.data",
											setter: "ExpressionSetter"
										} }
									},
									loop: {
										open: !0,
										data: {
											type: "EXPRESSION",
											value: "$$context.stateManager.bannerState.state.imgList"
										},
										forName: "item",
										forIndex: "index",
										key: "",
										name: ""
									},
									condition: !0,
									children: [{
										style: [{
											value: {
												type: "EXPRESSION",
												value: "$$context.stateManager.bannerState.state.currentPage === $$context.loopData.index ? 'white' : 'rgba(0,0,0,0.3)'"
											},
											property: "background"
										}],
										props: {
											width: "",
											height: "",
											$$attributes: [{
												key: "onClick",
												value: {
													type: "FUNCTION",
													value: "function click() {\n  console.log(222, $$context.loopData);\n}"
												}
											}],
											children: {
												type: "EXPRESSION",
												value: ""
											}
										},
										componentName: "CBlock",
										configure: {
											propsSetter: {
												"$$attributes.0.value": {
													name: "$$attributes.0.value",
													setter: "FunctionSetter"
												},
												children: {
													name: "children",
													setter: "ExpressionSetter"
												}
											},
											advanceSetter: { "loop.data": {
												name: "loop.data",
												setter: "ExpressionSetter"
											} }
										},
										loop: {
											open: !1,
											data: {
												type: "EXPRESSION",
												value: ""
											},
											forName: "item",
											forIndex: "index",
											key: "",
											name: ""
										},
										condition: !0,
										id: "5mu9jm",
										css: {
											class: "c_5mu9jm",
											value: [{
												state: "normal",
												media: [],
												text: "border-radius: 4px;width: 10px;height: 10px; "
											}]
										}
									}],
									css: {
										class: "c_jn98v0",
										value: [{
											state: "normal",
											media: [],
											text: "width: 10px;height: 10px;background-color: rgba(200,200,200,0.5);border-radius: 4px; "
										}]
									}
								}],
								configure: {
									propsSetter: {},
									advanceSetter: {}
								},
								loop: {
									open: !1,
									data: [],
									forName: "item",
									forIndex: "index",
									key: "",
									name: ""
								},
								condition: !0,
								title: "CContainer-thumbail",
								css: {
									class: "c_bl87pg",
									value: [{
										state: "normal",
										media: [],
										text: "animation-duration: 1;"
									}]
								}
							}
						],
						configure: {
							propsSetter: {},
							advanceSetter: {}
						},
						state: {
							currentPage: 1,
							imgList: [
								"https://images.unsplash.com/photo-1584080277544-2db5b2c2d9dd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
								"https://images.unsplash.com/photo-1486046866764-e426b5b93d98?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2091&q=80",
								"https://images.unsplash.com/photo-1534803005787-fa0b3987f6fc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1502&q=80"
							]
						},
						loop: {
							open: !1,
							data: [],
							forName: "item",
							forIndex: "index",
							key: "",
							name: ""
						},
						condition: !0,
						nodeName: "bannerState",
						css: {
							class: "c_2vi5b1",
							value: [{
								state: "normal",
								media: [],
								text: "height: 500px;position: relative;width: 100%;overflow: hidden;margin: 0 auto;border-radius: 10px; "
							}]
						}
					}],
					configure: {
						propsSetter: {},
						advanceSetter: {}
					},
					title: "CContainer-bg",
					css: {
						class: "ef9vms",
						value: [{
							state: "normal",
							media: [],
							text: "padding: 20px 40px;"
						}]
					}
				},
				{
					props: { content: "Hello Chamelon EG" },
					componentName: "CText",
					id: "qpbnqn",
					configure: {
						propsSetter: {},
						advanceSetter: {}
					},
					classNames: [{
						name: "",
						status: {
							type: "EXPRESSION",
							value: "true"
						}
					}],
					css: {
						class: "c_qpbnqn",
						value: [{
							state: "normal",
							media: [{
								type: "max-width",
								value: "767",
								text: " color: pink;"
							}, {
								type: "max-width",
								value: "991"
							}],
							text: "text-align: center;width: 100%;display: inline-block;font-size: 80px;padding: 20px;box-sizing: border-box;font-weight: bold;background-image: linear-gradient(         45deg,         #CA4246 16.666%,          #E16541 16.666%,          #E16541 33.333%,          #F18F43 33.333%,          #F18F43 50%,          #8B9862 50%,          #8B9862 66.666%,          #476098 66.666%,          #476098 83.333%,          #A7489B 83.333%);background-color: #CA4246;background-size: 100%;background-repeat: repeat;color: transparent;-webkit-background-clip: text; "
						}]
					}
				},
				{
					style: [
						{
							value: "20px 40px",
							property: "margin"
						},
						{
							value: "20px",
							property: "border-radius"
						},
						{
							value: "hidden",
							property: "overflow"
						},
						{
							value: "2px 2px 5px rgba(0,0,0,0.2)",
							property: "box-shadow"
						},
						{
							value: "hidden",
							property: "Webkit-backface-visibility"
						}
					],
					props: {
						width: "100px",
						height: "100px"
					},
					componentName: "CContainer",
					id: "ekv045",
					children: [{
						props: {
							width: "100%",
							height: "",
							src: "https://vjs.zencdn.net/v/oceans.mp4",
							autoPlay: "",
							controls: !0,
							$$attributes: []
						},
						componentName: "CVideo",
						id: "vu26ll",
						configure: {
							propsSetter: {
								autoplay: {
									name: "autoplay",
									setter: "ExpressionSetter"
								},
								autoPlay: {
									name: "autoPlay",
									setter: "BooleanSetter"
								}
							},
							advanceSetter: {}
						},
						css: {
							class: "c_vu26ll",
							value: [{
								state: "normal",
								media: [],
								text: "margin: auto;display: block; "
							}]
						}
					}],
					configure: {
						propsSetter: {},
						advanceSetter: {}
					},
					title: "video-container"
				}
			],
			configure: {
				propsSetter: {},
				advanceSetter: {}
			},
			title: "bg-CContainer",
			classNames: [],
			css: {
				class: "ckakcd",
				value: [{
					state: "normal",
					media: [],
					text: "background-color: white;width: 100%;overflow: auto; "
				}]
			}
		}]
	},
	thirdLibs: [{
		package: "dayjs",
		name: "dayjs",
		version: "1.0.0"
	}, {
		package: "antd",
		name: "antd",
		version: "1.0.0"
	}],
	assets: [{
		package: "dayjs",
		globalName: "dayjs",
		resources: [{ src: "https://cdn.jsdelivr.net/npm/dayjs@1.11.12/dayjs.min.js" }]
	}]
}, f = {
	version: "1.0.0",
	name: "BaseDemoPage",
	componentsMeta: [],
	componentsTree: {
		id: "1",
		componentName: "RootContainer",
		props: { a: 1 },
		state: {
			b: 1,
			buttonVisible: !0,
			modalVisible: !1
		},
		children: [
			{
				id: "row11111",
				componentName: "Row"
			},
			{
				id: "globalStateText",
				componentName: "div",
				props: { children: {
					type: "EXPRESSION",
					value: "\"rowState to reshow: \" + $$context.stateManager.RowState.state.rowMark"
				} }
			},
			{
				id: "div1",
				componentName: "div",
				children: [{
					id: "div1btn",
					componentName: "Button",
					state: { list: [
						11,
						22,
						33,
						44,
						55
					] },
					props: { children: {
						type: "EXPRESSION",
						value: "$$context.loopData.index"
					} },
					loop: {
						open: !0,
						data: {
							type: "EXPRESSION",
							value: "$$context.state.list"
						},
						key: {
							type: "EXPRESSION",
							value: "$$context.loopData.item"
						}
					}
				}]
			},
			{
				id: "div12222",
				componentName: "div",
				children: ["566666"]
			},
			{
				id: "Modal",
				componentName: "Modal",
				refId: "ModalRef",
				props: {
					open: {
						type: "EXPRESSION",
						value: "$$context.globalState.modalVisible"
					},
					onCancel: {
						type: "FUNCTION",
						value: "\n            function (a) {\n                $$context.updateGlobalState({\n                 modalVisible: false\n                });\n            }\n            "
					}
				},
				children: ["I am a modal"]
			},
			{
				id: "999",
				componentName: "Button",
				state: { a: 1 },
				props: {
					type: "primary",
					onClick: {
						type: "FUNCTION",
						value: "function onClick(a) {\n              console.log(a);\n              $$context.updateState({a: $$context.state.a + 1})\n              $$context.updateGlobalState({\n                buttonVisible: !$$context.globalState.buttonVisible,\n                modalVisible: !$$context.globalState.modalVisible\n              })\n            }"
					},
					children: ["控制右边按钮的显示隐藏"]
				}
			},
			{
				id: "2",
				componentName: "Button",
				state: { a: 1 },
				props: {
					type: "primary",
					onClick: {
						type: "FUNCTION",
						value: "function onClick(a) {\n              console.log(a);\n              $$context.updateState({a: $$context.state.a + 1})\n              $$context.updateGlobalState({ b: $$context.globalState.b + 1})\n            }"
					},
					children: {
						type: "EXPRESSION",
						value: "$$context.globalState.b"
					}
				},
				condition: {
					type: "EXPRESSION",
					value: "$$context.globalState.buttonVisible"
				}
			},
			{
				id: "3",
				componentName: "Table",
				state: {
					a: 3,
					data: [
						{
							key: "1",
							name: "John Brown",
							age: 32,
							address: "New York No. 1 Lake Park",
							tags: ["nice", "developer"]
						},
						{
							key: "2",
							name: "Jim Green",
							age: 42,
							address: "London No. 1 Lake Park",
							tags: ["loser"]
						},
						{
							key: "3",
							name: "Joe Black",
							age: 32,
							address: "Sidney No. 1 Lake Park",
							tags: ["cool", "teacher"]
						}
					]
				},
				props: {
					name: 111,
					testArrayString: [
						1,
						2,
						3,
						4,
						5
					],
					columns: [
						{
							title: "Name",
							dataIndex: "name",
							key: "name",
							render: {
								type: "SLOT",
								renderType: "FUNC",
								params: [
									"val",
									"record",
									"index"
								],
								value: [{
									id: "5",
									componentName: "Row",
									children: [{
										id: "6",
										componentName: "Button",
										props: {
											mark: "nameRender",
											children: {
												type: "EXPRESSION",
												value: "$$context.params.val"
											}
										}
									}, {
										id: "7",
										componentName: "Col",
										children: [{
											componentName: "Button",
											props: { mark: "nameRender" },
											children: [{
												id: "8",
												componentName: "div",
												children: ["I am div"]
											}]
										}]
									}]
								}, {
									id: "99898999",
									componentName: "Button",
									children: ["123"]
								}]
							}
						},
						{
							title: "Age",
							dataIndex: "age",
							key: "age"
						},
						{
							title: "Address",
							dataIndex: "address",
							key: "address"
						},
						{
							title: "Tags",
							key: "tags",
							dataIndex: "tags"
						},
						{
							title: "Action",
							key: "action"
						}
					],
					dataSource: {
						type: "EXPRESSION",
						value: "$$context.state.data"
					}
				},
				configure: {}
			},
			{
				id: "4",
				componentName: "Row",
				state: { rowMark: 1 },
				nodeName: "RowState",
				children: [
					{
						componentName: "div",
						props: { children: {
							type: "EXPRESSION",
							value: "\"rowState to reshow: \" + $$context.stateManager.RowState.state.rowMark"
						} }
					},
					{
						id: "10",
						componentName: "Col",
						children: [{
							id: "11",
							componentName: "Button",
							children: ["123 木头人"]
						}]
					},
					{
						id: "12",
						componentName: "Input",
						props: {
							value: {
								type: "EXPRESSION",
								value: "$$context.globalState.b"
							},
							onChange: {
								type: "FUNCTION",
								value: "\n                  function(value) {\n                    console.log(value, $$context);\n                    $$context.updateGlobalState({\n                      b: value.target.value\n                    })\n                  }\n                "
							}
						}
					},
					{
						componentName: "div",
						children: ["2222", {
							componentName: "div",
							children: ["1111", {
								componentName: "Button",
								props: { onClick: {
									type: "FUNCTION",
									value: "\n                          function (a) {\n                            console.log(a);\n                            const stateManager = $$context.stateManager;\n                            const state = stateManager.RowState.state;\n                            stateManager.RowState.updateState({\n                              rowMark: state.rowMark  +1\n                            })\n                          }\n                        "
								} },
								children: ["change row state value"]
							}]
						}]
					}
				]
			}
		]
	}
}, p = {
	version: "1.0.0",
	name: "BaseDemoPage",
	componentsMeta: [],
	componentsTree: {
		id: "1",
		componentName: "RootContainer",
		props: { a: 1 },
		children: [
			{
				id: "externalTitleText",
				componentName: "div",
				props: { children: {
					type: "EXPRESSION",
					value: "\"Page 外部 props：\" + ($PAGE_PROPS.externalTitle || \"\")"
				} }
			},
			{
				id: "globalStateText",
				componentName: "div",
				injectEnvList: ["COMPONENTS"],
				props: { children: {
					type: "EXPRESSION",
					value: "\"rowState to reshow: \" + $$context.stateManager.RowState.state.rowMark"
				} }
			},
			{
				componentName: "Card",
				state: { link: "https://www.baidu2.com/state" },
				props: {
					onClick1: {
						type: "FUNCTION",
						value: "\n              function (a) {\n                console.log(a, $$context);\n                const stateManager = $$context.stateManager;\n                const methods = $$context.getMethods();\n                const state = stateManager.RowState.state;\n                stateManager.RowState.updateState({\n                  rowMark: state.rowMark  +1\n                })\n              }\n            "
					},
					onClick: {
						type: e.ACTION,
						handler: [
							{
								id: 1,
								type: "RUN_CODE",
								sourceCode: "",
								value: "\n                    console.log('12321312');\n                    return 555;\n                  ",
								next: 2
							},
							{
								id: 2,
								next: 3,
								type: "JUMP_LINK",
								link: "https://www.baidu.com"
							},
							{
								type: "JUMP_LINK",
								link: {
									type: "EXPRESSION",
									value: "$$context.state.link"
								}
							},
							{
								id: "3",
								next: "4",
								type: "JUMP_LINK",
								link: {
									type: "FUNCTION",
									sourceCode: "function () {\n                    return $$context.state.link;\n                  }",
									value: "function () {\n                  console.log('jump3');\n                    return $$context.state.link;\n                  }"
								}
							},
							{
								id: 4,
								type: n.REQUEST_API,
								apiPath: {
									type: "FUNCTION",
									value: "\n                    function () {\n                      console.log($$context);\n                      return 'https://www.api.com'\n                    }\n                  "
								},
								body: {
									a: "123",
									f: 456,
									b: {
										type: "EXPRESSION",
										value: "$$context.state.link"
									},
									c: {
										type: "FUNCTION",
										sourceCode: "function () {\n                    return $$context.state.link;\n                  }",
										value: "function () {\n                    return $$context.state.link;\n                  }"
									}
								},
								responseVarName: "APIResult",
								afterSuccessResponse: [
									{
										id: "t1",
										next: "t2",
										type: "RUN_CODE",
										value: "\n                      console.log($$context, $$response);\n                      console.log(77889999, apiResult)\n                  "
									},
									{
										id: "t2",
										next: "t3",
										type: "CALL_NODE_METHOD",
										nodeId: "testNode",
										methodName: "sayHello",
										args: [
											123,
											{
												type: "EXPRESSION",
												value: "$$context.state.a"
											},
											{
												type: "FUNCTION",
												value: "\n                        function (apiResult) {\n                          console.log('apiResult 99999', apiResult, $$response);\n                          return 890;\n                        }\n                      "
											}
										],
										returnVarName: "callNodeReturnVar"
									},
									{
										type: "RUN_CODE",
										id: "t3",
										next: "t4",
										value: "\n                      console.log(9898989, apiResult, $$context, $$response, $$actionVariableSpace);\n                      console.log(77889999,callNodeReturnVar, APIResult)\n                  "
									},
									{
										id: "t4",
										next: "t5",
										type: n.ASSIGN_VALUE,
										valueType: "STATE",
										currentValue: {
											type: "EXPRESSION",
											value: "APIResult"
										},
										targetValueName: {
											nodeId: "xxx",
											keyPath: "apiResult"
										}
									},
									{
										id: "t5",
										next: "t6",
										type: n.ASSIGN_VALUE,
										valueType: "MEMORY",
										currentValue: {
											type: "FUNCTION",
											value: "function (apiResult) {\n                        console.log(6677, apiResult, APIResult);\n                        return apiResult;\n                      }\n                      "
										},
										targetValueName: "tempApiResult1"
									}
								],
								afterFailedResponse: [{
									type: "RUN_CODE",
									id: "t7",
									next: "t8",
									value: "\n                      console.log($$context, $$response);\n                      console.log('errrrror', apiResult)\n                  "
								}]
							}
						]
					}
				},
				eventListener: [{
					name: "ON_DID_RENDER",
					func: {
						type: e.ACTION,
						handler: [{
							id: "12",
							type: "RUN_CODE",
							value: "\n                    console.log('12321312', $$context, $PARAMS);\n                    console.log('Component Did Mount')\n                    return 'Component Did Mount'\n                "
						}]
					}
				}, {
					name: "ON_WILL_DESTROY",
					func: {
						type: e.ACTION,
						handler: [{
							id: "123",
							type: "RUN_CODE",
							value: "\n                    console.log('12321312', $$context, params);\n                    console.log('Component ON_WILL_DESTROY')\n                    return 'Component ON_WILL_DESTROY'\n                "
						}]
					}
				}],
				methods: [{
					name: "getAge",
					type: "FUNCTION",
					value: "function getAge() {\n            console.log(12);\n            }"
				}],
				children: ["Action login flow Demo"]
			},
			{
				id: "testNode",
				componentName: "Button",
				props: { onClick: {
					type: "FUNCTION",
					value: "\n              function (a) {\n                console.log(a, $$context);\n                const stateManager = $$context.stateManager;\n                const methods = $$context.getMethods();\n                const state = stateManager.RowState.state;\n                stateManager.RowState.updateState({\n                  rowMark: state.rowMark  +1\n                })\n              }\n            "
				} },
				methods: [{
					name: "getAge",
					type: "FUNCTION",
					value: "function getAge() {\n            console.log(12);\n            }"
				}],
				children: ["change row state value"]
			},
			{
				id: "4",
				componentName: "Row",
				state: { rowMark: 1 },
				nodeName: "RowState",
				children: [{
					componentName: "div",
					props: { children: {
						type: "EXPRESSION",
						value: "\"rowState to reshow: \" + $$context.stateManager.RowState.state.rowMark"
					} }
				}]
			}
		]
	}
}, m = {
	version: "1.0.0",
	name: "EmptyPage",
	componentsMeta: [],
	componentsTree: {
		componentName: t.ROOT_CONTAINER,
		props: {},
		children: []
	}
}, h = {
	version: "1.0.0",
	name: "LayoutPage",
	componentsMeta: [{
		componentName: "GridItem",
		name: "GridItem",
		package: "@chamn/material",
		version: "0.0.46",
		destructuring: !0,
		exportName: "GridItem"
	}, {
		componentName: "GridLayout",
		name: "GridLayout",
		package: "@chamn/material",
		version: "0.0.46",
		destructuring: !0,
		exportName: "GridLayout"
	}],
	componentsTree: {
		componentName: "RootContainer",
		props: { a: 1 },
		state: {
			b: 2,
			buttonVisible: !0,
			modalVisible: !1
		},
		configure: {
			propsSetter: {},
			advanceSetter: {}
		},
		children: [{
			props: { breakpoints: [
				{
					w: 350,
					label: "mobile"
				},
				{
					w: 768,
					label: "xs"
				},
				{
					w: 992,
					label: "sm"
				},
				{
					w: 1200,
					label: "md"
				},
				{
					w: 1920,
					label: "lg"
				},
				{
					w: 3600,
					label: "xl"
				}
			] },
			componentName: "GridLayout",
			id: "hps09b",
			children: [
				{
					props: { responsive: [
						{
							label: "lg",
							info: {
								x: 0,
								y: 11,
								w: 14,
								h: 3
							},
							x: "",
							y: ""
						},
						{
							label: "md",
							info: {
								x: 0,
								y: 4,
								w: 24,
								h: 2
							},
							x: "",
							y: ""
						},
						{
							label: "xs",
							info: {
								x: 6,
								y: 7,
								w: 14,
								h: 3
							}
						},
						{
							label: "sm",
							info: {
								x: 0,
								y: 11,
								w: 14,
								h: 3
							}
						}
					] },
					componentName: "GridItem",
					id: "vnuvg0",
					configure: {
						propsSetter: {},
						advanceSetter: {}
					},
					style: [
						{
							property: "background-color",
							value: "rgb(139,187,17)"
						},
						{
							property: "background-image",
							value: ""
						},
						{
							property: "background-size",
							value: ""
						},
						{
							property: "background-repeat",
							value: ""
						}
					]
				},
				{
					props: { responsive: [
						{
							label: "lg",
							info: {
								x: 9,
								y: 7,
								w: 15,
								h: 4
							},
							x: "",
							y: ""
						},
						{
							label: "md",
							info: {
								x: 9,
								y: 6,
								w: 15,
								h: 3
							},
							x: "",
							y: ""
						},
						{
							label: "xs",
							info: {
								x: 5,
								y: 5,
								w: 16,
								h: 2
							}
						},
						{
							label: "sm",
							info: {
								x: 9,
								y: 7,
								w: 15,
								h: 4
							}
						}
					] },
					componentName: "GridItem",
					configure: {
						propsSetter: {},
						advanceSetter: {}
					},
					id: "pl20rg",
					style: [
						{
							property: "background-color",
							value: "rgb(250,140,22)"
						},
						{
							property: "background-image",
							value: ""
						},
						{
							property: "background-size",
							value: ""
						},
						{
							property: "background-repeat",
							value: ""
						}
					]
				},
				{
					props: { responsive: [
						{
							label: "lg",
							info: {
								x: 0,
								y: 5,
								w: 13,
								h: 2
							},
							x: "",
							y: ""
						},
						{
							label: "md",
							info: {
								x: 0,
								y: 9,
								w: 13,
								h: 5
							},
							x: "",
							y: ""
						},
						{
							label: "xs",
							info: {
								x: 4,
								y: 3,
								w: 18,
								h: 2
							}
						},
						{
							label: "sm",
							info: {
								x: 0,
								y: 5,
								w: 13,
								h: 2
							}
						}
					] },
					componentName: "GridItem",
					configure: {
						propsSetter: {},
						advanceSetter: {}
					},
					id: "b7l87q",
					style: [
						{
							property: "background-color",
							value: "rgb(114,46,209)"
						},
						{
							property: "background-image",
							value: ""
						},
						{
							property: "background-size",
							value: ""
						},
						{
							property: "background-repeat",
							value: ""
						}
					]
				},
				{
					props: { responsive: [
						{
							label: "lg",
							info: {
								x: 0,
								y: 0,
								w: 24,
								h: 3
							},
							x: "",
							y: ""
						},
						{
							label: "md",
							info: {
								x: 0,
								y: 0,
								w: 24,
								h: 2
							},
							x: "",
							y: ""
						},
						{
							label: "xs",
							info: {
								x: 0,
								y: 0,
								w: 24,
								h: 3
							}
						},
						{
							label: "sm",
							info: {
								x: 0,
								y: 0,
								w: 24,
								h: 3
							}
						}
					] },
					componentName: "GridItem",
					configure: {
						propsSetter: {},
						advanceSetter: {}
					},
					id: "egib67",
					style: [
						{
							property: "background-color",
							value: "rgb(245,34,45)"
						},
						{
							property: "background-image",
							value: ""
						},
						{
							property: "background-size",
							value: ""
						},
						{
							property: "background-repeat",
							value: ""
						}
					]
				}
			],
			configure: {
				propsSetter: {},
				advanceSetter: {}
			}
		}]
	},
	thirdLibs: [{
		package: "dayjs",
		name: "dayjs",
		version: "1.0.0"
	}, {
		package: "antd",
		name: "antd",
		version: "1.0.0"
	}],
	assets: [{
		package: "@chamn/material",
		globalName: "ChamnCommonComponents",
		resources: [{ src: "https://cdn.jsdelivr.net/npm/@chamn/material/dist/index.js" }, { src: "https://cdn.jsdelivr.net/npm/@chamn/material/dist/style.css" }]
	}]
}, g = {
	version: "1.0.0",
	name: "ButtonShowcasePage",
	componentsMeta: [
		{
			componentName: "Card",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Button",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Divider",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Space",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Tag",
			name: "antd",
			package: "antd",
			version: "5.x"
		}
	],
	componentsTree: {
		id: "button-showcase-root",
		componentName: "RootContainer",
		children: [{
			id: "button-showcase-card",
			componentName: "Card",
			props: {
				title: "Button 样式展示",
				style: {
					maxWidth: 920,
					margin: "0 auto"
				}
			},
			children: [
				{
					id: "button-showcase-description",
					componentName: "div",
					props: { style: {
						marginBottom: 16,
						color: "#666"
					} },
					children: ["覆盖 Ant Design Button 常用类型、禁用态和块级布局。"]
				},
				{
					id: "button-showcase-types",
					componentName: "Space",
					props: {
						wrap: !0,
						size: 12
					},
					children: [
						{
							id: "button-primary",
							componentName: "Button",
							props: { type: "primary" },
							children: ["Primary"]
						},
						{
							id: "button-default",
							componentName: "Button",
							children: ["Default"]
						},
						{
							id: "button-dashed",
							componentName: "Button",
							props: { type: "dashed" },
							children: ["Dashed"]
						},
						{
							id: "button-link",
							componentName: "Button",
							props: { type: "link" },
							children: ["Link"]
						},
						{
							id: "button-danger",
							componentName: "Button",
							props: { danger: !0 },
							children: ["Danger"]
						},
						{
							id: "button-disabled",
							componentName: "Button",
							props: { disabled: !0 },
							children: ["Disabled"]
						}
					]
				},
				{
					id: "button-showcase-divider",
					componentName: "Divider"
				},
				{
					id: "button-showcase-block",
					componentName: "Button",
					props: {
						type: "primary",
						block: !0
					},
					children: ["Block Button"]
				},
				{
					id: "button-showcase-tags",
					componentName: "Space",
					props: {
						wrap: !0,
						size: 8,
						style: { marginTop: 16 }
					},
					children: [
						{
							id: "button-tag-model",
							componentName: "Tag",
							props: { color: "blue" },
							children: ["CPageDataType"]
						},
						{
							id: "button-tag-props",
							componentName: "Tag",
							props: { color: "green" },
							children: ["props"]
						},
						{
							id: "button-tag-children",
							componentName: "Tag",
							props: { color: "purple" },
							children: ["children"]
						}
					]
				}
			]
		}]
	}
}, _ = {
	version: "1.0.0",
	name: "InteractiveButtonPage",
	componentsMeta: [
		{
			componentName: "Alert",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Button",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Card",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Space",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Tag",
			name: "antd",
			package: "antd",
			version: "5.x"
		}
	],
	componentsTree: {
		id: "interactive-button-root",
		componentName: "RootContainer",
		children: [{
			id: "interactive-button-card",
			componentName: "Card",
			props: {
				title: "节点 State 与条件渲染",
				style: {
					maxWidth: 920,
					margin: "0 auto"
				}
			},
			children: [
				{
					id: "interactive-button-description",
					componentName: "div",
					props: { style: {
						marginBottom: 16,
						color: "#666"
					} },
					children: ["两个按钮分别验证节点 state 更新和 condition 表达式。"]
				},
				{
					id: "interactive-button-actions",
					componentName: "Space",
					props: {
						wrap: !0,
						size: 12
					},
					children: [{
						id: "interactive-counter-button",
						nodeName: "interactiveCounterButton",
						componentName: "Button",
						state: { count: 0 },
						props: {
							type: "primary",
							children: {
								type: e.EXPRESSION,
								value: "`点击次数：${$$context.state.count}`"
							},
							onClick: {
								type: e.FUNCTION,
								value: "function () { $$context.updateState({ count: $$context.state.count + 1 }); }"
							}
						}
					}, {
						id: "interactive-detail-button",
						nodeName: "interactiveDetailButton",
						componentName: "Button",
						state: { visible: !1 },
						props: {
							children: {
								type: e.EXPRESSION,
								value: "$$context.state.visible ? \"隐藏详情\" : \"显示详情\""
							},
							onClick: {
								type: e.FUNCTION,
								value: "function () { $$context.updateState({ visible: !$$context.state.visible }); }"
							}
						}
					}]
				},
				{
					id: "interactive-counter-tag",
					componentName: "Tag",
					props: {
						color: "blue",
						style: {
							display: "inline-block",
							marginTop: 16
						},
						children: {
							type: e.EXPRESSION,
							value: "`Store count: ${$$context.stateManager.interactiveCounterButton.state.count}`"
						}
					}
				},
				{
					id: "interactive-detail-alert",
					componentName: "Alert",
					condition: {
						type: e.EXPRESSION,
						value: "$$context.stateManager.interactiveDetailButton.state.visible"
					},
					props: {
						type: "success",
						showIcon: !0,
						message: "条件渲染已启用",
						description: "Alert 根据 interactiveDetailButton 的 state.visible 渲染。",
						style: { marginTop: 16 }
					}
				}
			]
		}]
	}
}, v = {
	version: "1.0.0",
	name: "LoopButtonPage",
	componentsMeta: [
		{
			componentName: "Button",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Card",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Space",
			name: "antd",
			package: "antd",
			version: "5.x"
		},
		{
			componentName: "Tag",
			name: "antd",
			package: "antd",
			version: "5.x"
		}
	],
	componentsTree: {
		id: "loop-button-root",
		componentName: "RootContainer",
		state: { releases: [
			{
				id: "render",
				title: "Render",
				description: "渲染节点、props 和事件处理。",
				status: "stable"
			},
			{
				id: "condition",
				title: "Condition",
				description: "表达式决定节点是否输出。",
				status: "testing"
			},
			{
				id: "loop",
				title: "Loop",
				description: "循环数据生成重复节点。",
				status: "ready"
			}
		] },
		children: [{
			id: "loop-button-title",
			componentName: "div",
			props: { style: {
				margin: "0 auto 16px",
				maxWidth: 920,
				color: "#666"
			} },
			children: ["循环使用 RootContainer state 中的 releases 数据。"]
		}, {
			id: "loop-button-card",
			componentName: "Card",
			loop: {
				open: !0,
				data: {
					type: e.EXPRESSION,
					value: "$$context.stateManager.globalState.state.releases"
				},
				forName: "release",
				forIndex: "index",
				key: {
					type: e.EXPRESSION,
					value: "$$context.loopData.release.id"
				},
				name: ""
			},
			props: {
				title: {
					type: e.EXPRESSION,
					value: "$$context.loopData.release.title"
				},
				style: {
					maxWidth: 920,
					margin: "0 auto 12px"
				}
			},
			children: [{
				id: "loop-button-description",
				componentName: "div",
				props: { children: {
					type: e.EXPRESSION,
					value: "$$context.loopData.release.description"
				} }
			}, {
				id: "loop-button-actions",
				componentName: "Space",
				props: {
					size: 12,
					style: { marginTop: 16 }
				},
				children: [{
					id: "loop-button-status",
					componentName: "Tag",
					props: {
						color: "green",
						children: {
							type: e.EXPRESSION,
							value: "$$context.loopData.release.status"
						}
					}
				}, {
					id: "loop-button-action",
					componentName: "Button",
					props: {
						type: "link",
						children: "查看循环数据",
						onClick: {
							type: e.FUNCTION,
							value: "function () { console.log($$context.loopData.release); }"
						}
					}
				}]
			}]
		}]
	}
}, y = (e) => JSON.stringify(e, null, 2), b = 480, x = 500;
function S({ children: e, schema: t, schemaTitle: n = "原始 Schema", onSchemaChange: d, updateDelay: f = 300 }) {
	let [p, m] = s(!0), [h, g] = s(!1), [_, v] = s(() => y(t)), [S, C] = s(), w = o(null), T = o(null), E = o(null), D = o(0);
	a(() => {
		if (t === E.current) {
			E.current = null;
			return;
		}
		v(y(t)), C(void 0);
	}, [t]), a(() => () => {
		w.current && clearTimeout(w.current), T.current = null;
	}, []);
	let O = i((e) => {
		T.current = e;
		let t = () => {
			let e = T.current;
			T.current = null, w.current = null, D.current = Date.now(), e && (E.current = e, d?.(e));
		}, n = Date.now() - D.current;
		n >= f ? t() : w.current ||= setTimeout(t, f - n);
	}, [d, f]), k = i((e) => {
		let t = e || "";
		v(t);
		try {
			let e = JSON.parse(t);
			if (!e || Array.isArray(e) || typeof e != "object") throw Error("根节点必须是 JSON 对象");
			C(void 0), O(e);
		} catch (e) {
			C(e instanceof Error ? e.message : "JSON 格式错误");
		}
	}, [O]);
	return /* @__PURE__ */ u("div", {
		style: {
			position: "relative",
			minHeight: "100%"
		},
		children: [/* @__PURE__ */ l("div", {
			style: {
				boxSizing: "border-box",
				paddingRight: p && !h ? x : 40
			},
			children: e
		}), /* @__PURE__ */ u("aside", {
			style: {
				position: h ? "fixed" : "absolute",
				top: h ? 12 : 0,
				right: h ? 12 : 0,
				bottom: h ? 12 : void 0,
				left: h ? 12 : void 0,
				zIndex: h ? 10 : 1,
				width: h ? "auto" : p ? b : 40,
				border: "1px solid #e8e8e8",
				borderRadius: 8,
				background: "#fff",
				overflow: "hidden",
				transition: "width 200ms ease"
			},
			children: [/* @__PURE__ */ u("div", {
				style: {
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					height: 44,
					padding: p ? "0 8px 0 12px" : 0,
					borderBottom: p ? "1px solid #f0f0f0" : 0
				},
				children: [p && /* @__PURE__ */ l("strong", {
					style: { whiteSpace: "nowrap" },
					children: n
				}), /* @__PURE__ */ u("div", {
					style: {
						display: "flex",
						gap: 4
					},
					children: [p && /* @__PURE__ */ l("button", {
						type: "button",
						"aria-label": h ? "切换为原始宽度" : "切换为全屏",
						title: h ? "切换为原始宽度" : "切换为全屏",
						onClick: () => g((e) => !e),
						style: {
							width: 32,
							height: 32,
							flexShrink: 0,
							padding: 0,
							border: 0,
							borderRadius: 4,
							color: "#1f1f1f",
							background: "transparent",
							fontSize: 18,
							lineHeight: 1
						},
						children: /* @__PURE__ */ l("span", {
							"aria-hidden": "true",
							children: h ? "↙" : "⛶"
						})
					}), /* @__PURE__ */ l("button", {
						type: "button",
						"aria-label": p ? `收起 ${n}` : `展开 ${n}`,
						title: p ? `收起 ${n}` : `展开 ${n}`,
						onClick: () => m((e) => !e),
						style: {
							width: 32,
							height: 32,
							flexShrink: 0,
							padding: 0,
							border: 0,
							borderRadius: 4,
							color: "#1f1f1f",
							background: "transparent",
							fontSize: 20,
							lineHeight: 1
						},
						children: /* @__PURE__ */ l("span", {
							"aria-hidden": "true",
							children: p ? "›" : "‹"
						})
					})]
				})]
			}), p && /* @__PURE__ */ u(c, { children: [S && /* @__PURE__ */ l("div", {
				style: {
					padding: "8px 12px",
					color: "#cf1322",
					fontSize: 12
				},
				children: S
			}), /* @__PURE__ */ l(r, {
				height: h ? "calc(100vh - 70px)" : "calc(100vh - 170px)",
				language: "json",
				value: _,
				onChange: k,
				options: {
					automaticLayout: !0,
					formatOnPaste: !0,
					formatOnType: !0,
					minimap: { enabled: !1 },
					tabSize: 2,
					wordWrap: "on"
				}
			})] })]
		})]
	});
}
//#endregion
//#region src/material/index.ts
var C = [
	{
		title: "Table",
		componentName: "Table",
		npm: {
			name: "MockMaterial",
			package: "@chamn/mock-material",
			exportName: "Table",
			version: "1.0.0"
		},
		props: [
			{
				name: "name",
				title: "表名",
				valueType: "string",
				setters: [
					"TextAreaSetter",
					"StringSetter",
					{
						componentName: "ArraySetter",
						props: { item: {
							setters: [
								{
									componentName: "ShapeSetter",
									props: { elements: [
										{
											name: "name",
											title: "列名",
											valueType: "string",
											setters: ["StringSetter"]
										},
										{
											name: "dataIndex",
											title: "dataIndex",
											valueType: "string",
											setters: ["StringSetter"]
										},
										{
											name: "filteredValue",
											title: "过滤值",
											valueType: "array",
											setters: ["StringSetter"]
										}
									] },
									initialValue: {}
								},
								"StringSetter",
								{
									componentName: "SelectSetter",
									props: { options: [
										{
											value: "jack",
											label: "Jack"
										},
										{
											value: "lucy",
											label: "Lucy"
										},
										{
											value: "Yiminghe",
											label: "yiminghe"
										},
										{
											value: "disabled",
											label: "Disabled",
											disabled: !0
										}
									] }
								},
								"JSONSetter",
								"FunctionSetter",
								"ComponentSetter"
							],
							initialValue: ""
						} },
						initialValue: []
					},
					{
						componentName: "ExpressionSetter",
						initialValue: []
					}
				]
			},
			{
				name: "selectSetter",
				title: "select",
				valueType: "string",
				setters: [{
					componentName: "SelectSetter",
					props: { options: [
						{
							value: "jack",
							label: "Jack"
						},
						{
							value: "lucy",
							label: "Lucy"
						},
						{
							value: "Yiminghe",
							label: "yiminghe"
						},
						{
							value: "disabled",
							label: "Disabled",
							disabled: !0
						}
					] }
				}]
			},
			{
				name: "testArrayString",
				title: "数组字符串",
				valueType: "array",
				setters: [
					{
						componentName: "ArraySetter",
						props: { item: {
							setters: [
								"StringSetter",
								"SelectSetter",
								"JSONSetter",
								"FunctionSetter",
								"ComponentSetter"
							],
							initialValue: ""
						} },
						initialValue: []
					},
					{
						componentName: "ExpressionSetter",
						initialValue: []
					},
					"StringSetter",
					"SelectSetter",
					"JSONSetter",
					"FunctionSetter",
					"ComponentSetter"
				]
			},
			{
				name: "pagination",
				title: "分页",
				valueType: "object",
				setters: [{
					componentName: "ShapeSetter",
					props: { elements: [{
						name: "current",
						title: "当前页",
						valueType: "number",
						setters: ["NumberSetter", "ExpressionSetter"]
					}] },
					initialValue: {}
				}]
			},
			{
				name: "style",
				title: "样式",
				valueType: "object",
				setters: ["JSONSetter"]
			},
			{
				name: "columns",
				title: "数据列",
				valueType: "array",
				setters: [{
					componentName: "ArraySetter",
					props: { item: {
						setters: [
							{
								componentName: "ShapeSetter",
								props: { elements: [
									{
										name: "title",
										title: "列名",
										valueType: "string",
										setters: ["StringSetter", "NumberSetter"]
									},
									{
										name: "dataIndex",
										title: "dataIndex",
										valueType: "string",
										setters: ["StringSetter"]
									},
									{
										name: "render",
										title: "渲染组件",
										valueType: "component",
										setters: ["ComponentSetter"]
									},
									{
										name: "filteredValue",
										title: "过滤值",
										valueType: "array",
										setters: ["StringSetter"],
										condition: (e) => e.dataIndex === "1"
									}
								] },
								initialValue: {}
							},
							"StringSetter",
							"SelectSetter",
							"JSONSetter",
							"FunctionSetter",
							"ComponentSetter"
						],
						initialValue: {
							title: "Name",
							dataIndex: "Name",
							filteredValue: "123"
						}
					} },
					initialValue: []
				}, {
					componentName: "ExpressionSetter",
					initialValue: []
				}]
			},
			{
				name: "sorter",
				title: "排序",
				valueType: "function",
				setters: ["FunctionSetter", "ExpressionSetter"]
			},
			{
				name: "title",
				title: "表头",
				valueType: "component",
				setters: ["ComponentSetter"]
			}
		],
		snippets: [{
			title: "表格",
			snapshotText: "Table",
			category: "高级组件",
			schema: {
				props: {
					data: [{
						key: "1",
						name: "John Brown",
						age: 32,
						address: "New York No. 1 Lake Park",
						tags: ["nice", "developer"]
					}],
					columns: [{
						title: "Name",
						dataIndex: "name",
						key: "name"
					}]
				},
				children: ["I am a Div Table"]
			}
		}]
	},
	{
		title: "Modal",
		componentName: "Modal",
		npm: {
			package: "@chamn/mock-material",
			exportName: "Modal",
			version: "1.0.0",
			name: "Modal"
		},
		icon: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
		props: [{
			name: "visible",
			title: "可见性",
			valueType: "boolean",
			setters: ["BooleanSetter", "ExpressionSetter"]
		}],
		fixedProps: { open: !0 },
		rootSelector: ".ant-modal-content",
		snippets: [{
			title: "基础元素",
			snapshotText: "Modal",
			category: "高级组件",
			schema: {
				props: {},
				children: ["I am a Modal"]
			}
		}]
	},
	{
		title: "Button",
		componentName: "Button",
		npm: {
			package: "@chamn/mock-material",
			exportName: "Button",
			version: "1.0.0",
			name: "Button"
		},
		icon: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
		props: [
			{
				name: "setterTest",
				title: "setter test",
				valueType: "string",
				setters: [
					"AntDColorSetter",
					{
						componentName: "RadioGroupSetter",
						props: {
							options: [
								{
									label: "A",
									value: "a"
								},
								{
									label: "B",
									value: "b"
								},
								{
									label: "C",
									value: "c"
								}
							],
							optionType: "button",
							buttonStyle: "solid"
						}
					},
					"ColorSetter",
					"SliderSetter",
					"CSSSizeSetter",
					"BoxSizingSetter"
				]
			},
			{
				name: "setterTest2",
				title: "setter test2",
				valueType: "string",
				setters: [{
					componentName: "ColorSetter",
					hiddenLabel: !0
				}]
			},
			{
				name: "type",
				title: "按钮类型",
				valueType: "string",
				setters: [{
					componentName: "SelectSetter",
					props: { options: [
						{
							value: "primary",
							label: "primary"
						},
						{
							value: "link",
							label: "link"
						},
						{
							value: "",
							label: "Default"
						}
					] }
				}]
			},
			{
				name: "block",
				title: "块状按钮",
				valueType: "boolean",
				setters: ["BooleanSetter"],
				condition: (e) => e.type === "primary"
			},
			{
				name: "children",
				title: "文本",
				valueType: "string",
				setters: [{
					componentName: "StringSetter",
					initialValue: "123"
				}, "ExpressionSetter"]
			},
			{
				name: "onClick",
				title: "点击时",
				valueType: "function",
				setters: ["FunctionSetter", "ExpressionSetter"]
			},
			{
				name: "text1",
				title: "联动文本1",
				valueType: "string",
				setters: [{ componentName: "StringSetter" }],
				condition: (e) => e.type === "primary1"
			},
			{
				name: "text2",
				title: "联动文本2",
				valueType: "string",
				setters: [{ componentName: "StringSetter" }],
				condition: (e) => e.text1 === "1"
			},
			{
				name: "text3",
				title: "联动文本3",
				valueType: "string",
				setters: [{ componentName: "StringSetter" }, "ExpressionSetter"]
			}
		],
		advanceCustom: {
			onCopy: async () => {
				console.log("onCopy");
			},
			selectRectViewRender: (e) => (console.log(123, e), /* @__PURE__ */ l("div", {
				style: {
					width: "100%",
					height: "100%",
					pointerEvents: "none"
				},
				children: "123"
			})),
			hoverRectViewRender: () => /* @__PURE__ */ l(c, { children: "Hover" }),
			dropViewRender: (e) => (console.log("123213", e), /* @__PURE__ */ l(c, { children: "drop 11111" })),
			ghostViewRender: () => /* @__PURE__ */ l(c, { children: "Big Button" }),
			toolbarViewRender: () => /* @__PURE__ */ l(c, { children: "toolbar" }),
			canDragNode: async (e, t) => (console.log("canDragNode", e, t), t.event?.extraData?.type, !0),
			onDragging: async () => {
				console.log("onDragging");
			},
			onDrop: async () => (console.log("onDrop"), !0),
			onSelect: async () => (console.log("onSelect"), !0),
			onDelete: async () => (console.log("onDelete"), !0),
			onNewAdd: async (e, t) => (t.viewPortal.setView(/* @__PURE__ */ l("div", { children: "123" })), console.log("onNewAdd"), new Promise((e) => {
				setTimeout(() => {
					e(!0), t.viewPortal.clearView();
				}, 1e3);
			}))
		},
		snippets: [{
			title: "基础按钮",
			snapshot: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
			description: "自定义延迟插入 Button, 不能被选中, 不能拖拽",
			schema: {
				props: { type: "primary" },
				children: ["I am a Button"]
			}
		}]
	},
	{
		title: "CLayout",
		componentName: "CLayout",
		npm: {
			package: "@chamn/mock-material",
			exportName: "CLayout",
			version: "1.0.0",
			name: "CLayout"
		},
		icon: "Layout",
		disableEditorDragDom: { class: ["as44556", "resize-handle"] },
		props: [
			{
				name: "type",
				title: "按钮类型",
				valueType: "string",
				setters: [{
					componentName: "SelectSetter",
					props: { options: [
						{
							value: "primary",
							label: "primary"
						},
						{
							value: "link",
							label: "link"
						},
						{
							value: "",
							label: "Default"
						}
					] }
				}]
			},
			{
				name: "block",
				title: "块状按钮",
				valueType: "boolean",
				setters: ["BooleanSetter"],
				condition: (e) => e.type === "primary"
			},
			{
				name: "children",
				title: "文本",
				valueType: "string",
				setters: [{
					componentName: "StringSetter",
					initialValue: "123"
				}, "ExpressionSetter"]
			},
			{
				name: "onClick",
				title: "点击时",
				valueType: "function",
				setters: ["FunctionSetter", "ExpressionSetter"]
			},
			{
				name: "text1",
				title: "联动文本1",
				valueType: "string",
				setters: [{ componentName: "StringSetter" }],
				condition: (e) => e.type === "primary1"
			},
			{
				name: "text2",
				title: "联动文本2",
				valueType: "string",
				setters: [{ componentName: "StringSetter" }],
				condition: (e) => e.text1 === "1"
			},
			{
				name: "text3",
				title: "联动文本3",
				valueType: "string",
				setters: [{ componentName: "StringSetter" }, "ExpressionSetter"]
			}
		],
		snippets: [{
			title: "基础布局",
			description: "自定义延迟插入 Button, 不能被选中, 不能拖拽",
			snapshotText: "Layout",
			schema: {
				props: { type: "primary" },
				children: ["I am a Button"]
			}
		}]
	},
	{
		title: "Button",
		componentName: "Button",
		npm: {
			package: "@chamn/mock-material",
			exportName: "Button",
			name: "Button",
			version: "1.0.0"
		},
		icon: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
		props: [
			{
				name: "type",
				title: "按钮类型",
				valueType: "string",
				setters: [{
					componentName: "SelectSetter",
					props: { options: [
						{
							value: "primary",
							label: "primary"
						},
						{
							value: "link",
							label: "link"
						},
						{
							value: "",
							label: "Default"
						}
					] }
				}]
			},
			{
				name: "block",
				title: "块状按钮",
				valueType: "boolean",
				setters: ["BooleanSetter"],
				condition: (e) => e.type === "primary"
			},
			{
				name: "children",
				title: "文本",
				valueType: "string",
				setters: ["StringSetter", "ExpressionSetter"]
			},
			{
				name: "onClick",
				title: "点击时",
				valueType: "function",
				setters: ["FunctionSetter", "ExpressionSetter"]
			},
			{
				name: "text1",
				title: "联动文本1",
				valueType: "string",
				setters: [{ componentName: "StringSetter" }],
				condition: (e) => e.type === "primary1"
			},
			{
				name: "text2",
				title: "联动文本2",
				valueType: "string",
				setters: [{ componentName: "StringSetter" }],
				condition: (e) => e.text1 === "1"
			},
			{
				name: "text3",
				title: "联动文本3",
				valueType: "string",
				setters: [{ componentName: "StringSetter" }, "ExpressionSetter"]
			}
		],
		snippets: [
			{
				title: "自定义按钮",
				snapshot: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
				description: "我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件,我是 antd 的 Button 组件",
				schema: {
					props: { type: "primary" },
					children: ["I am a Button"]
				}
			},
			{
				title: "基础按钮",
				snapshot: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
				category: "基础控件",
				schema: {
					props: { type: "primary" },
					children: ["I am a Button"]
				}
			},
			{
				title: "基础按钮",
				snapshot: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
				category: "基础控件",
				schema: {
					props: { type: "primary" },
					children: ["I am a Button"]
				}
			},
			{
				title: "基础按钮",
				snapshot: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
				category: "基础控件1",
				schema: {
					props: { type: "primary" },
					children: ["I am a Button"]
				}
			},
			{
				title: "基础按钮",
				snapshot: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
				category: "基础控件2",
				schema: {
					props: { type: "primary" },
					children: ["I am a Button"]
				}
			},
			{
				title: "基础按钮",
				snapshot: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
				category: "基础控件3",
				schema: {
					props: { type: "primary" },
					children: ["I am a Button"]
				}
			},
			{
				title: "基础按钮",
				snapshot: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
				category: "基础控件4",
				schema: {
					props: { type: "primary" },
					children: ["I am a Button"]
				}
			}
		]
	},
	{
		title: "Div",
		componentName: "div",
		icon: "https://alifd.oss-cn-hangzhou.aliyuncs.com/fusion-cool/icons/icon-light/ic_light_button.png",
		props: [{
			name: "style",
			title: "样式",
			valueType: "object",
			setters: ["JSONSetter"]
		}],
		methods: [{
			name: "doAlert",
			params: [{ name: "msg" }],
			title: "打开警告提示"
		}, {
			name: "doAlert2",
			params: [{
				name: "msg",
				description: "警告内容",
				tsType: "string",
				example: "请求失败"
			}, {
				name: "count",
				description: "提示次数",
				tsType: "number",
				example: "1"
			}],
			title: "打开警告提示2"
		}],
		snippets: [{
			title: "基础元素",
			snapshotText: "Div",
			category: "HTML 元素",
			schema: {
				props: {},
				children: ["I am a Div tag"]
			}
		}]
	}
];
//#endregion
export { d as BasePage, f as BasePageBClient, g as ButtonShowcasePage, S as DemoCase, m as EmptyPage, _ as InteractiveButtonPage, h as LayoutPage, v as LoopButtonPage, C as Material, p as SamplePage };

//# sourceMappingURL=index.es.js.map